module.exports = __webpack_public_path__ + "9f7c544fac12f971ab1cee9cfe43926b.png";